"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Raw pixel values for grid spacing, defined by 2^n (excluding 2^1) and 24*(4*(2^n))

exports.fixedSpacing = ['0', '4', '8', '16', '24', '32', '64'];
exports.fixedScale = exports.fixedSpacing.concat(['96', '128', '192', '256', '384', '512', '768', '1024']);
exports.borderScale = ['0', '1', '2', '4']; // Values (em | rem) for grid spacing, which matches the above when `font-size: 12px`

exports.responsiveSpacing = ['0', '0.333', '0.667', '1.333', '2', '2.667', '5.333'];
exports.responsive = {
  0: exports.responsiveSpacing[0],
  4: exports.responsiveSpacing[1],
  8: exports.responsiveSpacing[2],
  16: exports.responsiveSpacing[3],
  24: exports.responsiveSpacing[4],
  32: exports.responsiveSpacing[5],
  64: exports.responsiveSpacing[6]
};